module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-box-1848dd99c2bae4cbfdb9a276928e0421.svg";